import "./ClientRegistrationMedicalHistoryAllergiesComponent.scss";
import * as Yup from "yup";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {ImageConfig, Misc} from "../../../../constants";
import {CommonService} from "../../../../shared/services";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import FormikTextAreaComponent
    from "../../../../shared/components/form-controls/formik-text-area/FormikTextAreaComponent";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import {setFormChangesData} from "../../../../store/actions/form-state.action";

interface ClientRegistrationMedicalHistoryAllergiesComponentProps {
    onNext: () => void;
    appointmentId: any
}

const ClientAllergiesValidationSchema = Yup.object({
    allergies: Yup.string().nullable(),
})

const ClientAllergiesFormInitialValues: any = {
    allergies: ''
}

const ClientRegistrationMedicalHistoryAllergiesComponent = (props: ClientRegistrationMedicalHistoryAllergiesComponentProps) => {

    const {onNext, appointmentId} = props;
    const [clientAllergiesFormInitialValues, setClientAllergiesFormInitialValues] = useState<any>(_.cloneDeep(ClientAllergiesFormInitialValues));
    const dispatch = useDispatch();
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    const {
        clientMedicalHistoryDetails,
        isClientMedicalHistoryDetailsLoaded,
    } = useSelector((state: IRootReducerState) => state.client);

    useEffect(() => {
        if (clientMedicalHistoryDetails) {
            setClientAllergiesFormInitialValues(clientMedicalHistoryDetails);
        }
    }, [clientMedicalHistoryDetails, isClientMedicalHistoryDetailsLoaded]);

    const onSubmit = useCallback((values: any, {setErrors, setSubmitting}: FormikHelpers<any>) => {
        const payload = {
            ...values,
            appointment_id: appointmentId ? appointmentId : currentUser?.appointment_id,
        };
        setSubmitting(true);
        CommonService._client.ClientMedicalHistoryQuestionnaireAllergiesDetailsSaveAPICall(payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setSubmitting(false);
                setClientAllergiesFormInitialValues(_.cloneDeep(values));
                dispatch(setFormChangesData(false));
                onNext();
            })
            .catch((error: any) => {
                CommonService.handleErrors(setErrors, error);
                setSubmitting(false);
            })
    }, [onNext, currentUser?.appointment_id, dispatch, appointmentId]);

    return (
        <div className={'client-registration-medical-history-allergies-component'}>
            <Formik initialValues={clientAllergiesFormInitialValues}
                    validationSchema={ClientAllergiesValidationSchema}
                    onSubmit={onSubmit}
                    validateOnChange={false}
                    validateOnBlur={true}
                    enableReinitialize={true}
                    validateOnMount={true}>
                {({values, isValid, isSubmitting, validateForm, dirty}) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                        if (dirty) {
                            dispatch(setFormChangesData(true));
                        }
                    }, [validateForm, values, dirty]);
                    return (
                        <Form noValidate={true} className={"t-form"}>
                            <div className="t-form-controls">
                                <Field name={'allergies'}>
                                    {
                                        (field: FieldProps) => (
                                            <FormikTextAreaComponent
                                                id={'allergies_input'}
                                                formikField={field}
                                                label={'Please list any allergies you have (ie. Medications, Food, Environmental, Insects, \n' +
                                                    'Adhesives, etc.):'}
                                                required={false}
                                                fullWidth={true}
                                                placeholder={'Enter your comments here'}/>
                                        )
                                    }
                                </Field>

                                <div className="t-form-actions">
                                    <ButtonComponent
                                        id={"next_btn"}
                                        size={'large'}
                                        type={"submit"}
                                        isLoading={isSubmitting}
                                        disabled={isSubmitting || !isValid}
                                        suffixIcon={<ImageConfig.ArrowRightCircle/>}
                                    >
                                        {values?.allergies !== '' ? "Next" : "Skip"}
                                    </ButtonComponent>
                                </div>
                            </div>
                        </Form>
                    )
                }}

            </Formik>
        </div>
    );

};

export default ClientRegistrationMedicalHistoryAllergiesComponent;
